import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormValue,
  setValidValue,
  getAutoTipo,
  getAutoModelo,
  getAutoMarca,
  getAutoSubMarca,
  getAutoDescripcion,
} from "../vehicleSlice";

export const useVehicleForm = () => {
  const dispatch = useDispatch();
  const { formValues, vehicle } = useSelector((state) => state.vehicle);

  const [fieldTouched, setFieldTouched] = useState({
    tipo: false,
    modelo: false,
    marca: false,
    subMarca: false,
    descripcion: false,
  });

  // Cargar catálogo inicial
  useEffect(() => {
    dispatch(getAutoTipo());
  }, [dispatch]);

  // Reaccionar en cascada a los cambios
  useEffect(() => {
    const { tipo, modelo, marca, subMarca } = formValues;

    if (tipo) dispatch(getAutoModelo({ tipo }));
    if (tipo && modelo) dispatch(getAutoMarca({ tipo, modelo }));
    if (tipo && modelo && marca) dispatch(getAutoSubMarca({ tipo, modelo, marca }));
    if (tipo && modelo && marca && subMarca)
      dispatch(getAutoDescripcion({ tipo, modelo, marca, subMarca }));
  }, [formValues, dispatch]);

  // Manejar cambio y dependencias
  const handleChange = useCallback(
    (fieldName) => (e) => {
      const value = e.target.value;

      if (formValues[fieldName] === value) return;

      dispatch(setFormValue({ field: fieldName, value }));

      const isValid = value !== "";
      dispatch(setValidValue({ field: fieldName, isValid }));
    },
    [formValues, dispatch]
  );

  // Manejar blur para mostrar errores
  const handleBlur = useCallback(
    (fieldName) => () => {
      setFieldTouched((prev) => ({ ...prev, [fieldName]: true }));
    },
    []
  );

  // Validar errores
  const getErrorMessage = (fieldName) => {
    const value = formValues[fieldName] || "";
    if (!value && fieldTouched[fieldName]) return "Selecciona una opción";
    return "";
  };

  const isFieldInvalid = (fieldName) => {
    const value = formValues[fieldName] || "";
    return !value && fieldTouched[fieldName];
  };

  return {
    vehicle,
    formValues,
    handleChange,
    handleBlur,
    getErrorMessage,
    isFieldInvalid,
  };
};
